import * as types from '../mutation-types';
import {unionState} from '../union-state'

const state = () =>({
    custom_statements: []
})

const actions = {
	fetchAll({ commit }, { financialFileId } = {}) {
		let configs = undefined;
		if (financialFileId){
			configs = { headers: { ['X-FinancialFileId']: financialFileId } }
		}
		return window.axios.get('CustomStatements', configs).then(response => {
			if (!financialFileId) {
				commit(types.STORE_CUSTOM_STATEMENTS, response.data)
			}
			return response.data;
		})
	},
	create({ commit }, {name}) {
		return window.axios.post(`CustomStatements`,null, {
			params:{name},
		}).then(response => {
			commit(types.STORE_ONE_CUSTOM_STATEMENT, response.data)
			return response.data;
		});
	},
	update({ commit }, {custom_statement}) {
		return window.axios.put(`CustomStatements/${custom_statement.id}`, 
			custom_statement.account_ids
		,{ params: {newName: custom_statement.name}})
		.then(response => {
			commit(types.STORE_ONE_CUSTOM_STATEMENT, response.data);
			return response.data;
		});
    },
    fetch({ commit }, { id }) {
		return window.axios.get(`CustomStatements/${id}`).then(response => {
			commit(types.STORE_ONE_CUSTOM_STATEMENT, response.data);
			return response.data;
		});
    },
    delete({ commit }, { id }) {
		return window.axios.delete(`CustomStatements/${id}`).then(() => {
			commit('', '')
		});
	},
}

const mutations = {
	[types.STORE_CUSTOM_STATEMENTS](state, custom_statements) {
		state.custom_statements = custom_statements;
	},
	[types.STORE_ONE_CUSTOM_STATEMENT](state, custom_statement) {
        state.custom_statements = unionState(state.custom_statements, [custom_statement]);
    },
    [types.DELETE_CUSTOM_STATEMENT](state, custom_statement) {
        state.custom_statements = unionState(state.custom_statements, [custom_statement]);
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
}

